const breakpoint = 768;
// 関数定義 **********************************************************************
const fadeInUp = () => {
  const fadeInTargets = document.querySelectorAll('.js-fadeInUp');
  fadeInTargets.forEach((target) => {
    gsap.fromTo(target,
      {
        y: 30,
        x: 0,
        autoAlpha: 0,
      },
      {
        y: 0,
        x: 0,
        autoAlpha: 1,
        stagger: 0.1,
        duration: 0.8,
        ease: "power1.inOut",
        scrollTrigger: {
          trigger: target,
          start: 'top 90%',
        }
      }
    );
  });
}
const fadeIn = () => {
  const OnlyfadeInTargets = document.querySelectorAll('.js-fadeIn');
  OnlyfadeInTargets.forEach((target) => {
    gsap.fromTo(target,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        duration: 0.8,
        stagger: 0.1,
        ease: "power1.inOut",
        scrollTrigger: {
          trigger: target,
          start: 'top 80%',
        }
      }
    );
  });
}

// FV ロードアニメ
// 円形画像（.js-topFvAnim）：移動なしで、その場でふわっとフェードイン。
// 装飾SVG（.js-topFvDeco）：時計の針のように回転しながらフェードイン。
//   blue  … △の尖った先端（右端・縦中央）を軸に 11時 → 9時（開始 +60°）
//   green … 開口部（穴）を真下スタート → 時計回りにカンプ位置へ（開始 -117°）
// 開始状態（非表示・回転）は即座に適用して FOUC を防ぎ、FV 関連アセット
// （円形画像 + 装飾 SVG）が揃った瞬間にアニメ開始する。window.load 待ちにすると
// Footer JS / SMF 等の全アセット読込完了まで遅延し LCP が悪化するため、
// FV 要素の load イベントのみを Promise.all で待つ。
// prefers-reduced-motion: reduce のときは matchMedia 不一致でアニメを実行せず通常表示。
const topFvAnim = () => {
  const images = document.querySelectorAll('.js-topFvAnim');
  const decos = document.querySelectorAll('.js-topFvDeco');
  if (!images.length && !decos.length) return;

  const mm = gsap.matchMedia();
  mm.add('(prefers-reduced-motion: no-preference)', () => {
    // 開始状態を即座に適用（チラつき防止）
    gsap.set(images, { autoAlpha: 0 });
    decos.forEach((target) => {
      const start = target.dataset.deco === 'green'
        ? { rotation: -117, autoAlpha: 0 }
        : { rotation: 60, transformOrigin: '100% 49.65%', autoAlpha: 0 };
      gsap.set(target, start);
    });

    const play = () => {
      // 円形画像：その場でふわっとフェードイン
      gsap.to(images, {
        autoAlpha: 1,
        duration: 1.2,
        ease: 'power2.out',
      });
      // 装飾SVG：回転しながらカンプ位置（rotation:0）へ
      gsap.to(decos, {
        rotation: 0,
        autoAlpha: 1,
        duration: 1.4,
        delay: 0.2,
        ease: 'power2.out',
      });
    };

    // FV 関連要素（円形画像 + 装飾 SVG）の load を個別に待つ。
    // window.load を待たないことで LCP を前倒し（fv_img1 が LCP element）。
    // load 完了とブラウザのペイント完了にはズレがあるため（Style & Layout 計算が重いと
    // load 解決のほうが先に来てアニメ途中の状態が見えてしまう）、double rAF で
    // 「次のフレームのペイント完了後」に play を発火させ、視覚的な開始と同期させる。
    const targets = [...images, ...decos];
    const waitFor = targets.map((el) => {
      if (el.complete && el.naturalWidth > 0) return Promise.resolve();
      return new Promise((resolve) => {
        el.addEventListener('load', resolve, { once: true });
        el.addEventListener('error', resolve, { once: true });
      });
    });
    Promise.all(waitFor).then(() => {
      requestAnimationFrame(() => requestAnimationFrame(play));
    });
  });
}

// 実行 **********************************************************************
document.addEventListener("DOMContentLoaded", function () {
  // FV ロードアニメ（BP 非依存・1回）
  topFvAnim();

  const mm = gsap.matchMedia();
  // SPの時
  mm.add(`screen and (max-width: ${breakpoint - 1}px)`, () => {
    fadeInUp();
  });
  // PCの時
  mm.add(`screen and (min-width: ${breakpoint}px)`, () => {
    fadeInUp();
  });
});
